import { Container } from "react-bootstrap";

function ComingSoon() {

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          Coming <strong className="purple">Soon...! </strong>
        </h1>
        <p style={{ color: "white" }}>
          I am working to provide blogs on this page.
        </p>
      </ Container>
    </ Container>
  )
};

export default ComingSoon;